import React from 'react'
import {
  DeleteButton,
  FunctionField,
  Show,
  SimpleShowLayout,
  TopToolbar,
  useRecordContext,
  useRedirect,
} from 'react-admin'
import { Button, Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { POINT_FIELDS, getPoint } from './points'

const PointsTable = () => {
  const record = useRecordContext() || {}
  return (
    <Card style={{ marginTop: 16, marginBottom: 16 }}>
      <CardContent>
        <Table>
          <TableHead>
            <TableRow><TableCell>Место</TableCell><TableCell>Баллы</TableCell></TableRow>
          </TableHead>
          <TableBody>
            {POINT_FIELDS.map(({ place, label }) => (
              <TableRow key={place}><TableCell>{label}</TableCell><TableCell>{getPoint(record, place) ?? '—'}</TableCell></TableRow>
            ))}
            <TableRow>
              <TableCell>1-е место без боя</TableCell>
              <TableCell>{(record.rating_points || []).find((item) => item.without_fights)?.points ?? '—'}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}

const LevelActions = () => {
  const record = useRecordContext() || {}
  const redirect = useRedirect()
  return (
    <TopToolbar>
      <Button
        color='primary'
        onClick={() => redirect('edit', 'tournament_levels', record.id)}
      >Редактировать</Button>
      <DeleteButton redirect='list' undoable={false} />
    </TopToolbar>
  )
}

const ShowTournamentLevel = (props) => (
  <Show {...props} title='Уровень турнира' actions={<LevelActions />}>
    <SimpleShowLayout>
      <FunctionField label='Название уровня турнира' render={(record) => record.tournament_level_title || record.title || '—'} />
      <PointsTable />
    </SimpleShowLayout>
  </Show>
)

export default ShowTournamentLevel
